import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneExperienceSummary = createAsyncThunk(
  "OneExperienceSummary/OneGetExperienceSummary",
  async (tE_PreviousExperienceSummaryId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_PreviousExperienceSummary/GetTE_PreviousExperienceSummaryData",
        {
          tE_PreviousExperienceSummaryId: tE_PreviousExperienceSummaryId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateExperienceSummary = createAsyncThunk(
  "ExperienceSummary/ValidateExperienceSummary",
  async (ExperienceSummary, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TE_PreviousExperienceSummary/ValidateTE_PreviousExperienceSummary",
        {
          projectName: ExperienceSummary.projectName,
          briefDescriptionOfProject:
            ExperienceSummary.briefDescriptionOfProject,
          yearOfImplementation: ExperienceSummary.yearOfImplementation,
          durationOfImplementationInMonths:
            ExperienceSummary.durationOfImplementationInMonths,
          countryWhereProjectWasImplemented:
            ExperienceSummary.countryWhereProjectWasImplemented,
          governorateRegion: ExperienceSummary.governorateRegion,
          nameOfProjectDonor: ExperienceSummary.nameOfProjectDonor,
          amountOfSupportReceived: ExperienceSummary.amountOfSupportReceived,
          contactPersonFromDonorOrganizationName:
            ExperienceSummary.contactPersonFromDonorOrganizationName,
          contactInformationEmailPhone:
            ExperienceSummary.contactInformationEmailPhone,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const OneExperienceSummary = createSlice({
  name: "OneExperienceSummary ",
  initialState: {
    OneExperienceSummary: {},
    loadingOneExperienceSummary: false,
    errorOneExperienceSummary: null,

    OneExperienceSummaryValidate: [],
    loadingOneExperienceSummaryValidate: false,
    errorOneOneExperienceSummaryValidate: null,
  },
  reducers: {
    restValidationExperienceSummary: (state, action) => {
      state.OneExperienceSummaryValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneExperienceSummary.pending, (state, action) => {
        state.loadingOneExperienceSummary = true;
        state.OneExperienceSummary = action.payload;
        state.errorOneExperienceSummary = null;
      })
      .addCase(GetOneExperienceSummary.fulfilled, (state, action) => {
        state.loadingOneExperienceSummary = false;
        state.OneExperienceSummary = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneExperienceSummary.rejected, (state, action) => {
        state.loadingOneExperienceSummary = false;
        state.errorOneExperienceSummary = action.payload;
      })

      .addCase(ValidateExperienceSummary.pending, (state, action) => {
        state.loadingOneExperienceSummaryValidate = true;
        state.OneExperienceSummaryValidate = action.payload;
        state.errorOneOneExperienceSummaryValidate = null;
      })
      .addCase(ValidateExperienceSummary.fulfilled, (state, action) => {
        state.loadingOneExperienceSummaryValidate = false;
        state.OneExperienceSummaryValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateExperienceSummary.rejected, (state, action) => {
        state.loadingOneExperienceSummaryValidate = false;
        state.errorOneOneExperienceSummaryValidate = action.payload;
      });
  },
});
export const { restValidationExperienceSummary } = OneExperienceSummary.actions;
export default OneExperienceSummary.reducer;
